export default (message = '') => ({
    message,
    show: false,

    init() {
        this.show = this.message !== '';

        this.$el.addEventListener('animationend', () => {
            this.show = false;
        });
    },

    announce(message) {
        this.message = message;
        this.show = true;

        // A message that lands while another shows gets the full time on screen.
        this.$el.getAnimations({ subtree: true })
            .filter((animation) => animation instanceof CSSAnimation)
            .forEach((animation) => {
                animation.currentTime = 0;
            });
    },
});
